<template>
  <div class="build__container">
    <h3 class="build__title">Ready To Build Your Community?</h3>
    <button class="started__btn">Get Started For Free</button>
  </div>
</template>
<script>
export default {};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;700&display=swap");
.build__container {
  font-family: "Open Sans", sans-serif;
  height: 160px;
  background: white;
  -webkit-box-shadow: 0 0 6px #00252e;
  box-shadow: 0 0 6px #00252e;
  border-radius: 15px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.build__tittle {
  color: #00252e;
  font-size: 25px;
}

.started__btn {
  margin-top: 20px;
  width: 200px;
  height: 40px;
  border-radius: 20px;
  background: #ff52bf;
  -webkit-box-shadow: 0px 7px 5px lightslategray;
  box-shadow: 0px 7px 5px lightslategray;
  border: none;
  color: white;
}

.started__btn:hover {
  opacity: 0.7;
  -webkit-transform: translateY(-1px);
  transform: translateY(-1px);
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
</style>
